import React from 'react'
import PropTypes from 'prop-types'
import { Box, useStyleConfig } from '@chakra-ui/react'

function Toast(props) {
  const { variant, children, onClick, ...rest } = props
  const styles = useStyleConfig('Toast', { variant })
  return (
    <Box sx={styles} onClick={onClick} {...rest}>
      {children}
    </Box>
  )
}

Toast.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  variant: PropTypes.string,
}
export default Toast
